/* unplugin-vue-components disabled */import { render } from "./Zone.vue?vue&type=template&id=394fc25e&scoped=true"
import script from "./Zone.vue?vue&type=script&lang=js"
export * from "./Zone.vue?vue&type=script&lang=js"

import "./Zone.vue?vue&type=style&index=0&id=394fc25e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394fc25e"]])

export default __exports__